<template>
	<div>
		<el-form :inline="true">
			<el-form-item>
				<el-input
						v-model="searchForm.title"
						placeholder="模块标题"
						clearable
				>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-input
						v-model="searchForm.operName"
						placeholder="操作人员"
						clearable
				>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-select v-model="searchForm.operatorType" clearable placeholder="请选择操作类别">
					<el-option
							v-for="item in operatorTypeList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-select v-model="searchForm.status" clearable placeholder="请选择操作状态">
					<el-option
							v-for="item in statusList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button @click="getLogList">搜索</el-button>
			</el-form-item>
		</el-form>

		<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				border
				stripe>
			<el-table-column
					prop="title"
					label="模块标题">
			</el-table-column>
			<el-table-column
					prop="businessType"
					label="业务类型"
					width="80px">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.businessType === 0" type="success">其它</el-tag>
					<el-tag size="small" v-else-if="scope.row.businessType === 1" type="success">新增</el-tag>
					<el-tag size="small" v-else-if="scope.row.businessType === 2" type="success">修改</el-tag>
					<el-tag size="small" v-else-if="scope.row.businessType === 3" type="success">删除</el-tag>
				</template>
			</el-table-column>
			<el-table-column
					prop="method"
					label="方法名称"
					:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
					prop="operatorType"
					label="操作类别"
					width="100px">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.operatorType === 0" type="success">用户端</el-tag>
					<el-tag size="small" v-else-if="scope.row.operatorType === 1" type="success">平台管理端</el-tag>
				</template>
			</el-table-column>
			<el-table-column
					prop="operName"
					label="操作人员"
					width="110px"
					:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
					prop="operUrl"
					label="请求URL"
					:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
					prop="operParam"
					label="请求参数"
					:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
					prop="jsonResult"
					label="返回参数"
					:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column
					prop="status"
					label="操作状态"
					width="80px">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.status === 1" type="success">正常</el-tag>
					<el-tag size="small" v-else-if="scope.row.status === 0" type="danger">异常</el-tag>
				</template>
			</el-table-column>
			<el-table-column
					prop="operTime"
					label="操作时间"
					width="100px"
			>
			</el-table-column>

		</el-table>

		<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="page.current"
				:page-size="page.size"
				:total="page.total">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		name: "Log",
		data() {
			return {
				searchForm: {},
				page: {
					total: 0,
					size: 10,
					current: 1,
				},
				tableData: [],
				operatorTypeList: [
					{
						value: 0,
						label: '用户端'
					},{
						value: 1,
						label: '平台管理端'
					}
				],
				statusList: [
					{
						value: 0,
						label: '异常'
					},{
						value: 1,
						label: '正常'
					}
				]
			}
		},
		created() {
			this.getLogList(this.page)
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.page.size = val
				this.getLogList(this.page)
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page.current = val
				this.getLogList(this.page)
			},
			getLogList(page) {
				console.log(this.searchForm.title)
				this.$axios.post("/uxm/log/page", {
					title: this.searchForm.title,
					operName: this.searchForm.operName,
					operatorType: this.searchForm.operatorType,
					status: this.searchForm.status,
					current: page == null ? this.page.current : page.current,
					size: page == null ? this.page.size : page.size,
				}).then(res => {
					this.tableData = res.data.data.records
					this.page.size = res.data.data.size
					this.page.current = res.data.data.current
					this.page.total = res.data.data.total
				})
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}

</style>
